import { country } from "@/config/country";

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat(country.locale, {
    style: "currency",
    currency: country.currency,
    minimumFractionDigits: 2,
  }).format(amount);
};
